import React from 'react';
import { useState } from 'react'
import Startup from '../../asset/Startup.png'
import Freelancers from '../../asset/Freelancers.png'
import Constrain from '../../asset/Constrain.png'
import Remote from '../../asset/Remote.png'
import '../../App.css'

export default function WhoItsFor() {
    const [hoveredCard, setHoveredCard] = useState(null)

    const userTypes = [
        {
            id: 'startups',
            title: 'Startups',
            description: 'Small growing teams (2-10 people) needing collaboration',
            image: Startup,
            position: 'top',
        },
        {
            id: 'freelancers',
            title: 'Freelancers',
            description: 'Solo operators who need structure and focus',
            image: Freelancers,
            position: 'bottom',
        },
        {
            id: 'consultants',
            title: 'Consultants',
            description: 'Client-facing professionals who value location + image',
            image: Constrain,
            position: 'top',
        },
        {
            id: 'remote',
            title: 'Remote Workers',
            description: 'Employees of distributed companies seeking a quiet workspace',
            image: Remote,
            position: 'bottom',
        },
    ]

    const topRow = userTypes.slice(0, 2)
    const bottomRow = userTypes.slice(2)

    const renderCard = ({ id, title, description, image, position }) => (
        <div
            key={id}
            style={{ borderRadius: '20px' }}
            className={`flex flex-col cursor-pointer justify-center CollaborativeCatagory p-3 sm:p-4 items-center w-[200px] sm:w-[250px] h-[200px] sm:h-[250px] bg-[#FFF4F8] relative ${position === 'bottom' ? 'sm:bottom-[30px]' : ''}`}
            onMouseEnter={() => setHoveredCard(id)}
            onMouseLeave={() => setHoveredCard(null)}
        >
            <img className='w-[60px] sm:w-[80px] pb-3 sm:pb-4' src={image} alt={title} />
            <p className={`text-2xl sm:text-3xl font-regrade font-semibold text-center transition-all duration-300 ease-in-out ${hoveredCard === id ? 'text-[1.5rem] sm:text-[1.7rem]' : ''}`}>{title}</p>
            <p
                className={`text-center text-[#6D7E94] pt-2 text-sm transition-all duration-300 ease-in-out ${hoveredCard === id ? 'opacity-100 max-h-[100px]' : 'opacity-0 max-h-0 overflow-hidden'}`}
            >
                {description}
            </p>
        </div>
    )

    return (
        <div className='flex flex-col my-20 lg:flex-row items-center justify-around max-w-[75rem] py-8 mx-auto px-4 sm:px-6 gap-8 lg:gap-0'>
            <div className="w-[50%] shrink-0 left-[section] max-md:w-full max-md:max-w-none">
                <h2 className="text-[#966376] font-sans text-lg font-semibold leading-[27px] uppercase mb-3 max-sm:text-base">
                    Who It's For
                </h2>
                <h3 className="text-[#0B2549] font-regrade text-5xl font-semibold leading-[57.6px] mb-6 max-md:w-full max-md:text-[40px] max-sm:text-[32px]">
                Designed for<br/> Modern Businesses
                </h3>
                <p className="text-[#6D7E94] font-sans text-base font-[500] leading-[32.4px] w-[90%] mb-3.5 max-md:w-full max-sm:text-base">
                Our virtual office plans are perfect for professionals who need a legal, trusted business address—without the cost of a physical setup.
                </p>
                <div className="mt-3.5 relative">

                </div>
            </div>

            <div className="w-full lg:w-auto flex flex-col items-center">
                <div className='flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center'>
                    {topRow.map(renderCard)}
                </div>
                <div className='flex flex-col sm:flex-row relative sm:left-[40px] pt-4 sm:pt-8 gap-4 sm:gap-8 justify-center'>
                    {bottomRow.map(renderCard)}
                </div>
            </div>
        </div>
    )
}
